/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2023-2024 (original work) Open Assessment Technologies SA;
 */
import { getPermissionsGuard } from '@/core/guards/permissionsGuard';
import config from '@/config';

export const routing = [
    {
        path: [config.routes.studentSessions.sessions],
        guard: getPermissionsGuard([{ resource: 'portal.my-session', scopes: ['view'] }]),
        controller: () => import('./controllers/studentSessions')
    },
    {
        path: [config.routes.studentSessions.sessionExit],
        guard: getPermissionsGuard([{ resource: 'portal.my-session', scopes: ['view'] }]),
        controller: () => import('./controllers/sessionExit')
    },
    {
        path: [config.routes.studentSessions.reviewSession],
        guard: getPermissionsGuard([
            { resource: 'portal.my-session', scopes: ['review'] },
            { resource: 'portal.session', scopes: ['view'] },
            { resource: 'portal.support', scopes: ['view'] },
            { resource: 'portal.review-session', scopes: ['view'] }
        ]),
        controller: () => import('./controllers/reviewSession')
    },
    {
        path: [config.routes.studentSessions.finishedSessions],
        guard: getPermissionsGuard([{ resource: 'portal.my-session', scopes: ['view'] }]),
        controller: () => import('./controllers/finishedSessions')
    }
];
